import type { Descendant } from 'slate'

import type { SerializedRichText } from './types'

export default function deserializeRichText(text: SerializedRichText | null): Descendant[] {
  if (text == null) {
    return [{ type: 'paragraph', children: [{ text: '' }] }]
  }

  if (text.serialization_method === 'raw_html') {
    throw new Error('Rich text content is HTML, not an array')
  }

  if (text.serialization_method === 'slate_json_v1') {
    if (typeof text.content === 'string') {
      throw new Error('Rich text content is a string, not an array')
    }
    return text.content
  }

  return [
    {
      type: 'paragraph',
      children: [{ text: text.content }],
    },
  ]
}
